export default "__VITE_ASSET__CNE2GyoA__"